import angular from 'angular'
import moment from 'moment'
import { IFiltrosUltimosCV } from 'src/model/candidato-api'
import { BaseFiltrosComponent } from './base-filtros.component'

export type Filtro = {
  title: string
  desc: string
  page: string
  onactivate: (arg0: BaseFiltrosComponent) => void
  onend?: (arg0: BaseFiltrosComponent) => void
  filtros: (arg0: BaseFiltrosComponent) => IFiltrosUltimosCV
}

export function fechaMenos(amount?: number, unit?: moment.DurationInputArg2) {
  let _m = moment()

  if (amount) {
    _m.add(-1 * amount, unit)
  }

  return _m.toDate()
}

export const FILTRO_DEFECTO: IFiltrosUltimosCV = {
  idcv: null,
  limit: 20,
  end: null,
  start: null,
  mainq: null,
  q_value: null,
  estado: null,
  usuarioGestor: null,
  listarPublicos: null,
}

export const FILTROS: Filtro[] = [
  {
    title: 'Last 25',
    desc: 'Last 25',
    page: 'Last 25 Records',
    onactivate(ctrl) {
      ctrl.aplicaFiltros()
    },
    filtros(ctrl) {
      return angular.copy(FILTRO_DEFECTO)
    },
  },
  {
    title: 'Last 50',
    desc: 'Last 50',
    page: 'Last 50 Records',
    onactivate(ctrl) {
      ctrl.aplicaFiltros()
    },
    filtros(ctrl) {
      let _f = angular.copy(FILTRO_DEFECTO)

      _f.limit = 50

      return _f
    },
  },
  {
    title: 'Last week',
    desc: 'Last week',
    page: 'Last Week Records',
    onactivate(ctrl) {
      ctrl.aplicaFiltros()
    },
    filtros(ctrl) {
      return {
        idcv: null,
        limit: -1,
        end: fechaMenos(0),
        start: fechaMenos(7, 'd'),
        mainq: null,
        q_value: null,
        estado: null,
        usuarioGestor: null,
        listarPublicos: null,
      }
    },
  },
  {
    title: 'Last month',
    desc: 'Last month',
    page: 'Last Month Records',
    onactivate(ctrl) {
      ctrl.aplicaFiltros()
    },
    filtros(ctrl) {
      return {
        idcv: null,
        limit: -1,
        end: fechaMenos(0),
        start: fechaMenos(1, 'month'),
        mainq: null,
        q_value: null,
        estado: null,
        usuarioGestor: null,
        listarPublicos: null,
      }
    },
  },
  {
    title: 'Last year',
    desc: 'Last year',
    page: 'Last Year Records',
    onactivate(ctrl) {
      ctrl.aplicaFiltros()
    },
    filtros(ctrl) {
      return {
        idcv: null,
        limit: -1,
        end: fechaMenos(0),
        start: fechaMenos(1, 'y'),
        mainq: null,
        q_value: null,
        estado: null,
        usuarioGestor: null,
        listarPublicos: null,
      }
    },
  },
  {
    title: 'Filter by date',
    desc: 'Last month',
    page: 'Records Between Dates',
    onactivate(ctrl) {
      ctrl.filtrarFechas()
    },
    onend(ctrl) {
      ctrl.filtrarFechas(false)
    },
    filtros(ctrl) {
      return {
        idcv: null,
        limit: -1,
        end: (ctrl.filtroFechas.fin && new Date(ctrl.filtroFechas.fin)) || null,
        start: (ctrl.filtroFechas.inicio && new Date(ctrl.filtroFechas.inicio)) || null,
        mainq: null,
        q_value: null,
        estado: null,
        usuarioGestor: null,
        listarPublicos: null,
      }
    },
  },
  {
    title: 'Search Records',
    desc: 'Search',
    page: 'Search',
    onactivate(ctrl) {
      ctrl._actualizaMainQ()
      ctrl.filtrarPorMainQ()
    },
    onend(ctrl) {
      ctrl.filtrarPorMainQ(false)
    },
    filtros(ctrl) {
      return {
        idcv: null,
        limit: -1,
        end: null,
        start: null,
        mainq: ctrl.filtroQ.mainq,
        q_value: ctrl.filtroQ.value,
        estado: null,
        usuarioGestor: null,
        listarPublicos: null,
      }
    },
  },
]
